import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { ICRUDOptions } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { DELETE_PRODUCT_ECOMMERCE_CONFIG, GET_PRODUCT_ECOMMERCE_CONFIG, GET_PRODUCT_ECOMMERCE_CONFIGS, SAVE_PRODUCT_ECOMMERCE_CONFIG } from "../../../data/definitions/product-e-commerce-config.definition";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DataService } from "../../../data/services/data.service";
import { DeleteProductECommerceConfigMutation, DeleteProductECommerceConfigMutationVariables, DeletionResponse, GetProductECommerceConfigQuery, GetProductECommerceConfigQueryVariables, GetProductECommerceConfigsQuery, GetProductECommerceConfigsQueryVariables, ProductECommerceConfig, ProductECommerceConfigInput, SaveProductECommerceConfigMutation, SaveProductECommerceConfigMutationVariables, SearchInput } from "../../../generated/generated-types";

@Injectable({
    providedIn: 'root'
})
export class ProductECommerceConfigService extends BaseListService<ProductECommerceConfig> {
    constructor(
        private dataService: DataService,
        private baseDataService: BaseDataService,
        private systemService: SystemService
    ) {
        super();
    }

    getItems(searchInput?: SearchInput, o?: ICRUDOptions) {
        let fragment = GET_PRODUCT_ECOMMERCE_CONFIGS;

        if (o?.currentColumnConfig) {
            this.onlyKeepSelectedGraphQLNodesNew(fragment, o.currentColumnConfig.baseView, o.currentColumnConfig.columns);
        }

        return this.baseDataService.query<GetProductECommerceConfigsQuery, GetProductECommerceConfigsQueryVariables>(
            fragment, {
            input: searchInput as any
        });
    }

    getItem(id: string) {
        return this.baseDataService.query<GetProductECommerceConfigQuery, GetProductECommerceConfigQueryVariables>(
            GET_PRODUCT_ECOMMERCE_CONFIG, {
            id: id
        });
    }

    getItemStream(id: string) {
        return this.getItem(id).mapStream(x => x.getProductECommerceConfig);
    }

    async getItemData(id: string): Promise<ProductECommerceConfig> {
        let l = await lastValueFrom(this.getItem(id).single$);
        return l.getProductECommerceConfig as ProductECommerceConfig;
    }

    async deleteItem(id: string): Promise<DeletionResponse> {
        let res = await lastValueFrom(this.baseDataService.mutate<DeleteProductECommerceConfigMutation, DeleteProductECommerceConfigMutationVariables>(
            DELETE_PRODUCT_ECOMMERCE_CONFIG, {
            id: id
        }));

        return res.deleteProductECommerceConfig;
    }

    async saveItem(config: ProductECommerceConfig | ProductECommerceConfigInput) {
        let validated = await this.systemService.validateObject<ProductECommerceConfigInput>(config, "ProductECommerceConfigInput");

        let saved = await lastValueFrom(this.baseDataService.mutate<SaveProductECommerceConfigMutation, SaveProductECommerceConfigMutationVariables>(
            SAVE_PRODUCT_ECOMMERCE_CONFIG, {
            input: validated
        }));

        return saved.saveProductECommerceConfig as ProductECommerceConfig;
    }
}
